import React from 'react'
import {
  ExecuteOperationForModelOnPipe,
  ExecuteOperationOnPipe,
  useModelKey,
  WhenModelValue
} from '@morningtrain/react-resources'
import * as Icons from 'ui/icons'
import { Pipeline, TriggerPipelineOnClick } from '@morningtrain/react-helpers'

export function FieldStatus () {
  const modelKey = useModelKey()

  return (
    <div>
      <Pipeline>
        <ExecuteOperationForModelOnPipe resourceName='checklists.checklist_fields' operationName='toggle_filled' />
        <TriggerPipelineOnClick>
          <div>
            <WhenModelValue name='value' condition={1}>
              <Icons.CheckmarkCircle className='w-4 h-4 text-primary-500' />
            </WhenModelValue>
            <WhenModelValue name='value' condition={1} negate>
              <Icons.CheckmarkCircle className='w-4 h-4' />
            </WhenModelValue>
          </div>
        </TriggerPipelineOnClick>
        <ExecuteOperationOnPipe resourceName='checklists.checklists' operationName='read' id={modelKey} />
      </Pipeline>
    </div>
  )
}

export default FieldStatus
